module.exports = __webpack_public_path__ + "img/pc-contact-tg.525f9a96.webp";